<template>
  <div class="page-join">
    <mod-web-header title="实力供应商入驻申请" :status="2" />
    <com-join-step v-if="isJoinStep" :step="currentStepStatus" />

    <!-- 第1步 -->
    <form v-if="currentStepStatus === 1" class="step-wrapper" @submit.prevent="onSubmit">
      <textarea class="step-1" readonly>
        联塑商城注册服务协议
        欢迎阅读联塑商城注册服务协议(下称“本协议”)。本协议阐述之条款和条件适用于用户（您）使用广东联塑五金电气建材商城有限公司设立的联塑商城网所提供的进行交易和交流的各种工具和服务(下称“网站服务”)。
        第一条 接受条款
        1.1 以任何方式进入联塑商城网站（网址： www.lessomall.com）并使用服务即表示您已充分阅读、理解并同意接受本协议的条款和条件（以下合称“条款”）。进入使用方式，包括但不限于注册、登陆、点击、发布信息、进行交易及其他联塑商城网允许的使用方式。
        1.2 本协议内容包括协议正文、联塑商城现有的及不时更新的或新发布的会员服务条款、各类规则、制度、声明及用户与联塑商城网实际签署的各项服务协议、网络订单等，所有规则为协议不可分割的一部分，与协议正文具有同等法律效力。
        1.3 联塑商城网有权在法律允许范围内根据业务需要修订条款，修改后的条款一经公告立即生效。在联塑商城网修改服务条款后，您继续使用服务，则将视为您已接受了经修订的条款。因此，请您务必不时留意联塑商城网站信息更新情况。
        第二条 适用对象
        2.1 本协议适用于联塑商城网及联塑商城网的服务使用对象，对双方均具有法律约束力。服务使用对象包括联塑商城网会员、非会员及其它使用联塑商城网信息及技术服务的用户，本协议简称为“用户”或“您”。
        2.2 服务使用对象。本服务仅向能够根据相关法律订立具有法律约束力合约的主体提供。您确认，在您完成注册程序或以其他联塑商城网允许的方式实际使用服务时，您应当是具备完全民事权利能力和与所从事的民事行为相适应的行为能力的法人或其他组织。如您代表一家公司或其他法律主体在联塑商城网注册，则您声明和保证，您有权使该公司或该法律主体受本协议条款的约束。
        2.3 您与联塑商城网仅为独立订约人关系。本协议无意结成或创设任何代理、合伙、合营、雇用与被雇用或特许权授予与被授予关系。
        第三条 服务内容
        3.1 联塑商城网是集信息展示、产品发布、网上交易、品牌推广等多重服务于一体的电子商务平台，通过联塑商城网提供的平台服务，您可在联塑商城网网站组织的活动以及使用其它联塑商城网提供的信息服务及技术服务。
        3.2 联塑商城网保留在无须发出书面通知的情况下，自行决定对服务内容及其相关功能、应用软件变更、升级、修改，或因定期、不定期的维护而暂缓提供或永久地更改或停止部分或全部服务内容。
        第四条 会员注册
        4.1 注册资料。为方便您更好地使用服务，您可在联塑商城网网站进行注册成为会员。您同意按照注册网址相应页面的提示准确提供并及时更新您的资料，以使之真实、及时、完整和准确。
        4.2 注册费用。注册及使用会员相应的服务免费。您因进行交易、向本网站获取有偿服务或接触本网站服务器而发生的所有应纳税赋以及相关硬件、软件、通讯、网络服务及其他不应由本网站承担的费用均由您自行承担。联塑商城网保留修改费用条款的权利。一旦费用条款被修改，将立即在网站页面上予以公告。
        4.3 账户安全。您须自行负责对您的会员注册名和密码保密。您必须理解并明确表示通过其会员注册名和密码进行的任何操作（包括但不限于信息披露、发布信息、购买服务、产品交易等）均应被视为用户行为，其法律后果由用户承担。您同意：
        (a)不向任何第三者披露您的密码、与任何第三者共用您的密码或为任何未经批准的目的使用、转让、赠与您的密码;
        (b)如发现任何人未经授权使用您的会员注册名或密码或者发生其他违反保密约定的任何情况，您将立即通知联塑商城网，并提供必要证明材料;
        (c)您保证在每个上网时段结束时，以正确步骤离开网站。
        联塑商城网不能也不会对因您未能遵守本款约定而发生的任何损失负责。
        第五条 服务使用
        5.1 使用范围：本协议所述服务仅在联塑商城网范围内有效。联塑商城网网站范围是指www.lessomall.com及其所有下级域名所指向的网站和这些网站的所属网页。
        5.2 诚信经营：在使用服务中，您应遵守国家法律法规、本协议及其他各项服务条款、规则、制度等，诚实守信、合法经营。您保证并承诺您在本网站所从事的一切活动均符合以下要求：
        5.2.1 主体资质：您已具备相应的主体资格及经营资质。您应保证如您在联塑商城网所销售或从事交易的产品需政府审批或备案的，您已通过审批或备案且获得相应的许可；如您以商业伙伴名义提供、发布、张贴信息，您已事先得到该商业伙伴授权许可。
        5.2.2 资料提供：为保证您服务的正常使用，您应提供真实、准确、及时、完整的信息和联系方式，并在服务期内始终保持、维护、及时更新完善上述资料。联塑商城网对您资料有疑问时，您应积极履行配合义务。资料包括但不限于注册资料、认证资料或使用服务所必须的资料以及联塑商城网要求提交相应的证明材料等。
        5.2.3 产品描述：产品描述是由您提供的在联塑商城网上展示的文字描述、图画和/或照片，可以是(a) 对您拥有而您希望出售的产品的描述;或 (b) 对您正寻找的产品的描述。您必须将该等产品描述归入正确的类目内。联塑商城网不对产品描述的准确性或内容负责。
        5.2.4 报盘与回盘：所有各方接纳报盘或回盘将使所涉及的联塑商城网用户有义务完成交易。除非在特殊情况下，诸如您在提出报盘后、交易各方没有回应前实质性地更改对物品的描述或澄清任何文字输入错误或您未能证实交易所涉及的用户的身份等，报盘和承诺均不得撤回。
      </textarea>
      <div class="options">
        <label>
          <z-checkbox v-model="pushData.step1.accepted" />
          我已阅读并同意以上协议
        </label>
        <br />
        <button type="submit" class="submit-button" :disabled="!pushData.step1.accepted || pushing">
          下一步，填写公司资质信息
        </button>
      </div>
    </form>

    <!-- 第2步 -->
    <form
      v-else-if="currentStepStatus === 2"
      class="step-wrapper"
      method="post"
      action="/v1/seller/steps/2"
      enctype="multipart/form-data"
      @submit.prevent="onSubmit"
    >
      <p class="fields-title">公司及联系人信息</p>
      <com-filed label="公司名称：">
        <z-input
          v-model.trim="pushData.step2.company_name"
          type="text"
          placeholder="请输入营业执照上的公司名称，限制60个字符以内"
          :width="360"
          @focus="onFocus('company_name')"
          @blur="onBlur('company_name')"
        />
        <span v-if="errors.company_name" class="error">{{ errors.company_name }}</span>
      </com-filed>
      <com-filed :required="false" label="公司电话：">
        <z-input
          v-model.trim="pushData.company_phone_area"
          type="text"
          placeholder="区号"
          :width="70"
          @focus="onFocus('company_phone_area')"
          @blur="onBlur('company_phone_area')"
        />
        <span> - </span>
        <z-input
          v-model.trim="pushData.company_phone_num"
          type="text"
          placeholder="座机号码"
          :width="130"
          @focus="onFocus('company_phone_num')"
          @blur="onBlur('company_phone_num')"
        />
        <span v-if="errors.company_phone" class="error">{{ errors.company_phone }}</span>
      </com-filed>
      <com-filed label="店铺定位：">
        <div class="map-btn" @click="chooseMap">选择定位</div>
        <span v-if="pushData.step2.longitude && pushData.step2.latitude" class="map-data">
          <span>经度：{{ pushData.step2.longitude }}</span>
          <span>纬度：{{ pushData.step2.latitude }}</span>
        </span>
        <span v-else style="margin-left: 10px; color: #999">请选择店铺地图定位</span>
        <span v-if="errors.longitude" class="error">{{ errors.longitude }}</span>
      </com-filed>
      <com-filed label="店铺地址：">
        <select v-model="pushData.step2.province_id" @change="onChangeProvince">
          <option v-for="item in provinces" :key="item.id" :value="item.id">
            {{ item.name }}
          </option>
        </select>
        <select
          v-if="
            !/北京|天津|上海|重庆/.test(pushData.step2.city_name) && pushData.step2.city_id >= 0
          "
          v-model="pushData.step2.city_id"
          @change="onChangeCity"
        >
          <option v-for="item in citys" :key="item.id" :value="item.id">
            {{ item.name }}
          </option>
        </select>
        <select
          v-if="pushData.step2.district_id >= 0"
          v-model="pushData.step2.district_id"
          @change="onChangeDistrict"
        >
          <option v-for="item in districts" :key="item.id" :value="item.id">
            {{ item.name }}
          </option>
        </select>
        <select v-if="pushData.step2.town_id >= 0" v-model="pushData.step2.town_id">
          <option v-for="item in towns" :key="item.id" :value="item.id">
            {{ item.name }}
          </option>
        </select>
        <br />
        <z-input
          v-model.trim="pushData.step2.address"
          class="address"
          placeholder="具体地址，路牌，街道。 限制100个字符以内"
          :width="409"
          @focus="onFocus('address')"
          @blur="onBlur('address')"
        />
        <span v-if="errors.address" class="error">{{ errors.address }}</span>
      </com-filed>
      <com-filed label="员工总数：">
        <span class="unit-input people">
          <z-input
            v-model.number="pushData.step2.staff_num"
            placeholder="3-10000内整数"
            @focus="onFocus('staff_num')"
            @blur="onBlur('staff_num')"
          />
          <span class="unit">人</span>
        </span>
        <span v-if="errors.staff_num" class="error">{{ errors.staff_num }}</span>
      </com-filed>
      <com-filed label="联系人姓名：">
        <z-input
          v-model.trim="pushData.step2.linkman_name"
          placeholder="请输入真实姓名"
          :width="130"
          @focus="onFocus('linkman_name')"
          @blur="onBlur('linkman_name')"
        />
        <span v-if="errors.linkman_name" class="error">{{ errors.linkman_name }}</span>
      </com-filed>
      <com-filed class="last" label="联系人电话：">
        <p
          v-for="(item, index) in pushData.step2.linkman_phone"
          :key="index"
          style="margin-bottom: 10px"
        >
          <z-input
            v-model.trim="pushData.step2.linkman_phone[index]"
            :placeholder="`手机号码`"
            :width="190"
            @focus="onFocus('linkman_phone')"
            @blur="onBlur('linkman_phone')"
          />
          <span
            v-if="pushData.step2.linkman_phone.length > 1"
            class="icon-delete"
            @click="deletePhone(index)"
          />
          <span
            v-if="
              pushData.step2.linkman_phone.length < 5 &&
              index === pushData.step2.linkman_phone.length - 1
            "
            class="icon-add"
            @click="addPhone"
          />
          <span
            v-if="
              errors.linkman_phone && errors.linkman_phone.length && errors.linkman_phone[index]
            "
            class="error"
          >
            {{ errors.linkman_phone[index] }}
          </span>
        </p>
      </com-filed>
      <p class="fields-title">营业执照信息（副本）</p>
      <com-filed label="营业执照号：">
        <z-input
          v-model.trim="pushData.step2.license_id"
          placeholder="请输入营业执照注册号或者统一社会信用代码"
          :width="306"
          @focus="onFocus('license_id')"
          @blur="onBlur('license_id')"
        />
        <span v-if="errors.license_id" class="error">{{ errors.license_id }}</span>
      </com-filed>
      <com-filed label="法定经营范围：">
        <div class="scope clearfix">
          <z-input
            v-model.trim="pushData.step2.license_scope"
            element="textarea"
            :width="500"
            style="vertical-align: top"
            @focus="onFocus('license_scope')"
            @blur="onBlur('license_scope')"
          />
          <span v-if="errors.license_scope" class="error">{{ errors.license_scope }}</span>
        </div>
        <p class="input-tip">请按营业执照内的法定经营范围填写，此处最大字数限制为220个汉字</p>
      </com-filed>
      <com-filed label="营业执照电子版：">
        <com-file
          title="证照上传"
          name="license_image"
          :img="pushData.step2.license_image"
          @change="onChangeImage"
          @error="onErrorImage"
        />
        <span v-if="imagesErrors.license_image" class="image-error">
          {{ imagesErrors.license_image }}
        </span>
        <span v-if="errors.license_image" class="error">
          {{ errors.license_image }}
        </span>
        <br />
        <p class="input-tip">
          证照扫描文件或者电子版图片大小应为2M以内，格式为jpg、jpeg、png，请确保其文字清晰
        </p>
      </com-filed>
      <com-filed label="法人身份证电子版：">
        <span class="person">
          <com-file
            title="正面上传"
            name="license_person_id_front_image"
            :img="pushData.step2.license_person_id_front_image"
            @change="onChangeImage"
            @error="onErrorImage"
          />
        </span>
        <span class="person">
          <com-file
            title="反面上传"
            name="license_person_id_back_image"
            :img="pushData.step2.license_person_id_back_image"
            @change="onChangeImage"
            @error="onErrorImage"
          />
        </span>
        <span v-if="errors.license_person_id_front_image" class="error">
          {{ errors.license_person_id_front_image }}
        </span>
        <span v-else-if="errors.license_person_id_back_image" class="error">
          {{ errors.license_person_id_back_image }}
        </span>
        <span v-if="imagesErrors.license_person_id_front_image" class="image-error">
          {{ imagesErrors.license_person_id_front_image }}
        </span>
        <span v-else-if="imagesErrors.license_person_id_back_image" class="image-error">
          {{ imagesErrors.license_person_id_back_image }}
        </span>
        <p class="input-tip">
          身份证扫描文件应包括正反面，图片大小应为2M以内，格式为jpg、jpeg、png，请确保其文字清晰
        </p>
      </com-filed>
      <div class="options">
        <button type="button" class="button" @click="onBack">返回上一步</button>
        <button type="submit" class="submit-button" :disabled="isNextDisabled || pushing">
          下一步，填写店铺经营信息
        </button>
      </div>
      <!-- map-tencent -->
      <map-tencent
        v-if="isMapShow"
        :is-map-show.sync="isMapShow"
        :map-key="mapKey"
        :longitude.sync="pushData.step2.longitude"
        :latitude.sync="pushData.step2.latitude"
        @change="changeMap"
      />
    </form>

    <!-- 第3步 -->
    <form v-else-if="currentStepStatus === 3" class="step-wrapper" @submit.prevent="onSubmit">
      <p class="fields-title">店铺经营信息</p>
      <com-filed label="小程序店铺名称：">
        <z-input
          v-model="pushData.step3.shop_name"
          :width="320"
          placeholder="店铺名称有长度限制30个字符、15个汉字以内"
          @focus="onFocus('shop_name')"
          @blur="onBlur('shop_name')"
        />
        <span v-if="errors.shop_name" class="error">{{ errors.shop_name }}</span>
      </com-filed>
      <com-filed label="主营类目：">
        <template v-if="categories.length > 0">
          <div class="category">
            <span class="item">选择</span>
            <span class="item">已加入</span>
          </div>
          <z-transfer
            :data="categories"
            :targets="pushData.step3.shop_business_categories"
            :max="7"
            @change="onChangeCategories"
          />
          <span v-if="errors.shop_business_categories" class="error">
            {{ errors.shop_business_categories }}
          </span>
          <p class="input-tip">
            经营类目的正确选择关系到您店铺的商品发布与平台的关系，以及更有利于客户更准确地搜索到您店铺产品，最多可加7个
          </p>
        </template>
        <span v-else style="color: #999">加载中...</span>
      </com-filed>
      <div class="options">
        <button type="button" class="button" @click="onBack">返回上一步</button>
        <button type="submit" class="submit-button" :disabled="isNextDisabled || pushing">
          下一步，提交平台审核
        </button>
      </div>
    </form>

    <!-- 其他 -->
    <mod-user-status
      v-else
      :status.sync="currentStepStatus"
      :title="sellerInfo.shop_status_name"
      :message="sellerInfo.shop_status_message"
    />
    <div v-if="isJoinStep" class="slogan">做五金建材生意，就用 纵购商城 系统！</div>
    <template v-else>
      <mod-web-footer />
      <com-copyright />
    </template>
  </div>
</template>

<script>
import ModWebHeader from '@/components/mod-web-header'
import ComJoinStep from '@/components/com-join-step'
import ComFiled from '@/components/com-filed'
import ComFile from '@/components/com-file'
import ModWebFooter from '@/components/mod-web-footer'
import ComCopyright from '@/components/com-copyright'
import ModUserStatus from '@/components/mod-user-status'
import ZTransfer from '@/components/z-transfer'
import MapTencent from '@/components/map-tencent'
import { syncToken, getAccessToken, setUser, regExp } from '@/utils'
import {
  getSteps,
  setSteps,
  getRegions,
  getAreas,
  getCategories,
  getSeller,
  getRegionsLocation
} from '@/data'

export default {
  name: 'Join',
  components: {
    ModWebHeader,
    ComJoinStep,
    ComFiled,
    ComFile,
    ModWebFooter,
    ComCopyright,
    ModUserStatus,
    ZTransfer,
    MapTencent
  },
  data() {
    return {
      pushing: false,
      sellerInfo: {}, // 卖家信息
      currentStepStatus: null, // 当前步骤状态
      currentStepData: {}, // 当前步骤数据

      pushData: {
        // 需要提交的数据
        step1: {
          // 第1步
          accepted: false // 是否同意协议
        },
        step2: {
          // 第2步
          company_name: '', // 公司名称
          company_phone: '', // 公司电话
          longitude: null, // 经度
          latitude: null, // 纬度
          province_id: '', // 省id
          city_id: '', // 市id
          district_id: '', // 区id
          town_id: '', // 镇id
          address: '', // 详细地址
          staff_num: '', // 员工总数
          linkman_name: '', // 联系人
          linkman_phone: [''], // 联系人电话
          license_id: '', // 营业执照登记号
          license_scope: '', // 法定经营范围
          license_image: '', // 营业执照电子版
          license_person_id_front_image: '', // 法人身份证-正面
          license_person_id_back_image: '' // 法人身份证-背面
        },
        step3: {
          // 第3步
          shop_name: '', // 小程序店铺名称
          shop_business_categories: [] // 主营类目
        }
      },
      errors: {}, // 提交报错

      // others 第2步
      company_phone_area: '', // 公司电话-前
      company_phone_num: '', // 公司电话-后
      isMapShow: false, // 地图定位是否显示
      mapKey: '', // 地图定位key
      provinces: [], // 省
      citys: [], // 市
      districts: [], // 区
      towns: [], // 镇
      images: {}, // 图片
      imagesErrors: {}, //图片报错

      // others 第3步
      categories: [] // 主营类目
    }
  },
  computed: {
    // 是否为入驻步骤，步骤step=1/2/3
    isJoinStep() {
      return /^(1|2|3)$/.test(this.currentStepStatus)
    },
    // 是否禁用下一步按钮
    isNextDisabled() {
      const errors = { ...this.errors }
      delete errors.isFirstLoad
      return Object.keys(errors).length > 0
    }
  },
  watch: {
    async currentStepStatus() {
      this.sellerInfo = await getSeller()
      setUser({
        ...this.sellerInfo
      })
      this.fetchSteps()
    }
  },
  mounted() {
    this.getSellerInfo()
  },
  methods: {
    // 获取卖家信息
    async getSellerInfo() {
      this.sellerInfo = await getSeller()
      this.currentStepStatus = this.sellerInfo.shop_status
    },
    // 获取步骤
    async fetchSteps() {
      // 账号的入驻状态
      // show_welcome=0 表示入驻成功且访问过卖家中心
      if (this.sellerInfo.show_welcome === 0) {
        this.goto()
        return
      }

      // 初始化入驻步骤信息
      if (!this.isJoinStep) return
      this.currentStepData = await getSteps(this.currentStepStatus)
      if (this.currentStepStatus === 1) {
        Object.keys(this.pushData.step1).forEach((item) => {
          this.pushData.step1[item] = this.currentStepData[item]
        })
      }
      if (this.currentStepStatus === 2) {
        Object.keys(this.pushData.step2).forEach((item) => {
          if (item === 'linkman_phone') {
            this.pushData.step2[item] = this.currentStepData[item].length
              ? this.currentStepData[item]
              : ['']
          } else {
            this.pushData.step2[item] = this.currentStepData[item]
          }
        })
        let companyPhone = (this.currentStepData.company_phone || '').split('-')
        this.pushData.company_phone_area = companyPhone[0] || ''
        this.pushData.company_phone_num = companyPhone[1] || ''
        this.mapKey = this.currentStepData.tencent_map_key
        this.images = {} // 确保每次清空，否则图片报错数据会异常
        let regionsData = await getRegions()
        if (Array.isArray(regionsData.regions)) {
          this.provinces = regionsData.regions
          this.onChangeProvince() // 放在最后，确保shop是初始化后的数据
        }
      }
      if (this.currentStepStatus === 3) {
        Object.keys(this.pushData.step3).forEach((item) => {
          if (item === 'shop_business_categories') {
            this.pushData.step3[item] = this.currentStepData[item].map((item) => {
              return item.category_id
            })
          } else {
            this.pushData.step3[item] = this.currentStepData[item]
          }
        })
        let categoriesData = await getCategories()
        this.categories = (categoriesData.categories || []).map((item, idx) => {
          return {
            name: item.name,
            key: item.id,
            sort: idx
          }
        })
      }

      // Object.keys(this.pushData).forEach((key) => {
      //   this.onBlur(key, true)
      // })
    },
    // 跳转到登录界面 或 卖家中心
    goto() {
      const token = getAccessToken()

      if (!token) {
        syncToken()
        this.$router.push('/login')
        return
      }

      window.location.href = `${process.env.VUE_APP_SELLER_ORIGIN}`
    },
    // 返回上一步
    onBack() {
      this.currentStepStatus--
    },
    // 第2步/第3步 聚集焦点
    onFocus(name) {
      const item =
        name === 'company_phone_area' || name === 'company_phone_num' ? 'company_phone' : name
      const errors = { ...this.errors }
      delete errors.isFirstLoad
      errors[item] && delete errors[item]
      this.errors = errors
    },
    // 第2步/第3步 失去焦点
    onBlur(name, isFirstLoad) {
      let errors = { ...this.errors }

      if (this.currentStepStatus === 2) {
        if (name === 'company_name') {
          if (!this.pushData.step2.company_name) {
            errors.company_name = '* 请输入公司名称'
          }

          if (this.pushData.step2.company_name && this.pushData.step2.company_name.length > 60) {
            errors.company_name = '* 公司名称不能大于60个字符'
          }
        }

        if (
          (name === 'company_phone_area' || name === 'company_phone_num') &&
          (this.pushData.company_phone_area || this.pushData.company_phone_num)
        ) {
          if (
            !regExp.PHONE.test(
              `${this.pushData.company_phone_area}-${this.pushData.company_phone_num}`
            )
          ) {
            errors.company_phone = '* 座机号码格式不正确，请重新输入'
          }
        }

        if (name === 'address') {
          if (!this.pushData.step2.address) {
            errors.address = '* 请输入具体详细地址'
          }

          if ((this.pushData.step2.address || '').length > 100) {
            errors.address = '* 地址不能大于100个字符'
          }
        }

        if (name === 'staff_num') {
          if (
            /[^0-9]/.test(this.pushData.step2.staff_num) ||
            this.pushData.step2.staff_num < 3 ||
            this.pushData.step2.staff_num > 10000
          ) {
            errors.staff_num = '* 请重新输入3-10000以内整数值'
          }
        }

        if (name === 'linkman_name') {
          if (!this.pushData.step2.linkman_name) {
            errors.linkman_name = '* 请输入真实姓名'
          }

          if (!regExp.NAME.test(this.pushData.step2.linkman_name)) {
            errors.linkman_name = '* 请输入真实姓名，2-10个中文'
          }
        }

        if (name === 'linkman_phone') {
          errors.linkman_phone = []
          this.pushData.step2.linkman_phone.forEach((item, index) => {
            if (!item) {
              errors.linkman_phone[index] = '* 请输入联系人电话'
            } else {
              if (!regExp.MOBILE.test(item)) {
                errors.linkman_phone[index] = '* 手机号码格式不正确，请重新输入'
              } else {
                errors.linkman_phone[index] = ''
              }
            }
          })
          const isEntry = errors.linkman_phone.every((item) => {
            return item === ''
          })
          if (isEntry) {
            delete errors.linkman_phone
          }
        }

        if (name === 'license_id') {
          if (
            !(
              /^[A-Za-z0-9]{15}$/.test(this.pushData.step2.license_id) ||
              /^[A-Za-z0-9]{18}$/.test(this.pushData.step2.license_id)
            )
          ) {
            errors.license_id = '* 请正确输入15位注册号或18位信用代码'
          }
        }

        if (name === 'license_scope') {
          if (!this.pushData.step2.license_scope) {
            errors.license_scope = '* 请输入营业执照内的法定经营范围'
          }

          if ((this.pushData.step2.license_scope || '').length > 220) {
            errors.license_scope = '* 营业执照内的法定经营范围不能超过220个字'
          }
        }
      }

      if (this.currentStepStatus === 3) {
        if (name === 'shop_name') {
          if (!this.pushData.step3.shop_name) {
            errors.shop_name = '* 请输入小程序店铺名称'
          }

          if ((this.pushData.step3.shop_name || '').length > 30) {
            errors.shop_name = '* 店铺名称不能大于30个字符'
          }
        }

        if (this.pushData.step3.shop_business_categories.length <= 0) {
          errors.shop_business_categories = '* 店铺主营类目不能为空'
        }
      }

      if (Object.keys(errors).length > 0) {
        this.errors = isFirstLoad ? { isFirstLoad: true } : errors
      }
    },
    // 第2步 选择地图
    chooseMap() {
      this.isMapShow = true
      const errors = JSON.parse(JSON.stringify(this.errors))
      delete errors.longitude
      this.errors = JSON.parse(JSON.stringify(errors))
    },
    // 第2步 改变地图
    async changeMap(data) {
      const locationData = await getRegionsLocation(data.longitude, data.latitude)
      if (locationData.province_id) this.pushData.step2.province_id = locationData.province_id
      if (locationData.city_id) this.pushData.step2.city_id = locationData.city_id
      if (locationData.district_id) this.pushData.step2.district_id = locationData.district_id
      if (locationData.town_id) this.pushData.step2.town_id = locationData.town_id
      if (locationData.address) this.pushData.step2.address = locationData.address
      if (this.errors.address) delete this.errors.address
      this.onChangeProvince()
    },
    // 第2步 增加手机号码
    addPhone() {
      this.pushData.step2.linkman_phone.push('')
    },
    // 第2步 删除手机号码
    deletePhone(index) {
      this.pushData.step2.linkman_phone.splice(index, 1)
      if (this.errors.linkman_phone && this.errors.linkman_phone.length) {
        this.errors.linkman_phone.splice(index, 1)
        var isLinkmanPhoneErrorEmpty = this.errors.linkman_phone.every((item) => {
          return item === ''
        })
        if (isLinkmanPhoneErrorEmpty) delete this.errors.linkman_phone
      }
    },
    // 第2步 改变省
    async onChangeProvince() {
      const pushDataStep2 = { ...this.pushData.step2 }
      const province =
        this.provinces.find((item) => item.id === pushDataStep2.province_id) ||
        this.provinces[0] ||
        {}
      const areasData = await getAreas(province.id)
      pushDataStep2.province_id = province.id
      pushDataStep2.province_name = province.name

      if (Array.isArray(areasData.children) && areasData.children.length > 0) {
        this.citys = areasData.children
        this.pushData.step2 = { ...pushDataStep2 }
        this.onChangeCity(pushDataStep2.city_id)
      } else {
        delete pushDataStep2.city_id
        delete pushDataStep2.city_name
        delete pushDataStep2.district_id
        delete pushDataStep2.district_name
        delete pushDataStep2.town_id
        delete pushDataStep2.town_name
        this.pushData.step2 = { ...pushDataStep2 }
      }
    },
    // 第2步 改变市
    async onChangeCity(event) {
      const id =
        typeof event === 'number'
          ? event
          : event && event.target && event.target.value !== undefined && Number(event.target.value)
      const pushDataStep2 = { ...this.pushData.step2 }
      const city = this.citys.find((item) => item.id === id) || this.citys[0] || {}
      pushDataStep2.city_id = city.id
      pushDataStep2.city_name = city.name

      if (Array.isArray(city.children) && city.children.length > 0) {
        this.districts = city.children
        this.pushData.step2 = { ...pushDataStep2 }
        this.onChangeDistrict(pushDataStep2.district_id)
      } else {
        delete pushDataStep2.district_id
        delete pushDataStep2.district_name
        delete pushDataStep2.town_id
        delete pushDataStep2.town_name
        this.pushData.step2 = { ...pushDataStep2 }
      }
    },
    // 第2步 改变区
    async onChangeDistrict(event) {
      const id =
        typeof event === 'number'
          ? event
          : event && event.target && event.target.value !== undefined && Number(event.target.value)
      const pushDataStep2 = { ...this.pushData.step2 }
      let town
      const district = this.districts.find((item) => item.id === id) || this.districts[0] || {}
      pushDataStep2.district_id = district.id
      pushDataStep2.district_name = district.name

      if (Array.isArray(district.children) && district.children.length > 0) {
        this.towns = district.children
        town = this.towns.find((item) => item.id === pushDataStep2.town_id) || this.towns[0] || {}
        pushDataStep2.town_id = town.id
        pushDataStep2.town_name = town.name
        this.pushData.step2 = { ...pushDataStep2 }
      } else {
        delete pushDataStep2.town_id
        delete pushDataStep2.town_name
        this.pushData.step2 = { ...pushDataStep2 }
      }
    },
    // 第2步 改变图片
    onChangeImage(name, file) {
      this.images[name] = file
      this.imagesErrors[name] && this.$set(this.imagesErrors, name, '')
      this.onFocus(name)
    },
    // 第2步 图片报错
    onErrorImage(name, error) {
      this.$set(this.imagesErrors, name, error)
      setTimeout(() => {
        this.$set(this.imagesErrors, name, '')
      }, 2000)
    },
    // 第3步 改变主营类目
    onChangeCategories(targets) {
      const errors = { ...this.errors }
      this.pushData.step3.shop_business_categories = targets

      if (this.pushData.step3.shop_business_categories.length > 0) {
        delete errors.shop_business_categories
        this.errors = errors
      } else {
        this.onBlur('shop_business_categories')
      }
    },
    // 提交表单
    async onSubmit() {
      let data,
        errors = {}
      const { currentStepStatus } = this

      if (this.errors.isFirstLoad) {
        delete this.errors.isFirstLoad
      }

      // 第1步 提交
      if (currentStepStatus === 1) {
        const accepted = this.pushData.step1.accepted ? 1 : 0
        const params = {
          accepted
        }
        this.pushing = true
        data = await setSteps(1, params)
      }

      // 第2步 提交
      if (currentStepStatus === 2) {
        Object.keys(this.pushData.step2).forEach((key) => {
          this.onBlur(key)
        })

        if (!(this.pushData.step2.longitude && this.pushData.step2.latitude)) {
          errors.longitude = '* 请选择店铺地图定位'
        }

        if (!this.pushData.step2.license_image && !this.images.license_image) {
          errors.license_image = '* 请上传营业执照彩色照片'
        }

        if (
          !this.pushData.step2.license_person_id_front_image &&
          !this.images.license_person_id_front_image
        ) {
          errors.license_person_id_front_image = '* 请上传法人身份证正反面彩色照片'
        }

        if (
          !this.pushData.step2.license_person_id_back_image &&
          !this.images.license_person_id_back_image
        ) {
          errors.license_person_id_back_image = '* 请上传法人身份证正反面彩色照片'
        }

        this.errors = { ...this.errors, ...errors }

        if (Object.keys(this.errors).length > 0) {
          return
        }

        let postData = []
        Object.keys(this.pushData.step2).forEach((item) => {
          if (/^license_(image|person_id_front_image|person_id_back_image)$/.test(item)) {
            if (this.images[item] || !this.pushData.step2[item]) {
              postData.push({ name: item, value: this.images[item], type: 'file' })
            }
          } else if (/^company_phone_(area|num)$/.test(item)) {
            if (
              item === 'company_phone_area' &&
              this.pushData['company_phone_area'] &&
              this.pushData['company_phone_num']
            ) {
              postData.push({
                name: 'company_phone',
                value: `${this.pushData[item]}-${this.pushData['company_phone_num']}`
              })
            }
          } else if (this.pushData.step2[item]) {
            postData.push({ name: item, value: this.pushData.step2[item] })
          }
        })
        if (!('FormData' in window)) {
          this.pushing = true
          data = await setSteps(2, postData)
        } else {
          let formData = new FormData()
          postData.forEach((item) => {
            if (item.name === 'linkman_phone') {
              item.value.forEach((val) => {
                formData.append(item.name + '[]', val)
              })
            } else {
              formData.append(item.name, item.value)
            }
          })
          this.pushing = true
          const headers = { 'Content-Type': 'multipart/form-data' }
          data = await setSteps(2, formData, headers)
        }
      }

      // 第3步 提交
      if (currentStepStatus === 3) {
        const params = {
          shop_name: this.pushData.step3.shop_name,
          shop_business_categories: this.pushData.step3.shop_business_categories
        }
        this.pushing = true
        data = await setSteps(3, params)
      }

      // 提交成功/失败
      if (data.error_code === 0) {
        // 步骤提交成功，跳转到下一步
        this.currentStepStatus = data.status
      } else if (Array.isArray(data.errors)) {
        // 处理联系人电话错误
        let linkman_phone_errors = this.pushData.step2.linkman_phone.map(() => {
          return ''
        })
        data.errors.forEach((item) => {
          if (item.field.includes('linkman_phone')) {
            const currentIndex = Number(item.field[item.field.length - 1])
            linkman_phone_errors[currentIndex] = `* ${item.message}`
          } else {
            errors[item.field] = `* ${item.message}`
          }
        })
        const isEntry = linkman_phone_errors.every((item) => {
          return item === ''
        })
        if (!isEntry) errors['linkman_phone'] = linkman_phone_errors
        this.errors = errors
      }
      this.pushing = false
    }
  }
}
</script>

<style lang="postcss">
.page-join {
  .error,
  .image-error {
    font-size: 13px;
    color: #f00;
    margin-left: 10px;
  }

  .image-error {
    padding: 0 10px;
    background-color: #c81613;
    color: #fff;
    line-height: 30px;
    display: inline-block;
    vertical-align: top;
  }

  .submit-button,
  .button {
    height: 44px;
    background-color: #fabe00;
    border: none;
    width: 280px;
    border-radius: 5px;
    font-size: 16px;
    color: #fff;
    margin: 10px 20px 0 20px;
    cursor: pointer;

    &:disabled {
      color: #999;
      cursor: not-allowed;
      background-color: #ddd;
    }
  }

  .button {
    color: #666;
    background-color: #fff;
    border: 1px solid #dedee2;
    width: 180px;
  }

  .step-wrapper {
    background-color: #fff;
    width: 1000px;
    margin: 0 auto;
    padding: 20px;
    border: 1px solid #d1d6de;

    .step-1 {
      width: 940px;
      height: 380px;
      line-height: 2;
      border: 1px solid #e4e4e4;
      padding: 10px;
    }
  }

  .options {
    margin-top: 10px;
    text-align: center;

    .z-checkbox {
      vertical-align: -2px;
      margin-right: 5px;
    }
  }

  .slogan {
    height: 100px;
    width: 1000px;
    margin: 10px auto 0 auto;
    font-family: '微软雅黑 Oblique', '微软雅黑';
    font-style: oblique;
    font-size: 39px;
    color: #fff;
    text-align: center;
    line-height: 100px;
    background: url(~@/assets/images/bg-home-6.png) no-repeat center;
    background-size: auto 100px;
  }

  .fields-title {
    background-color: #eee;
    line-height: 36px;
    padding: 0 10px;
  }

  .category {
    .item {
      width: 193px;
      color: #999;
      display: inline-block;
    }
  }

  .input-tip {
    font-size: 12px;
  }

  input,
  select {
    line-height: 30px;
    height: 30px;
  }

  select {
    margin-right: 10px;
  }

  .scope {
    .z-input {
      height: 80px;
    }
  }

  .com-filed.last {
    margin-bottom: 40px;
  }

  .unit-input {
    position: relative;
    width: 160px;
    display: inline-block;
    height: 30px;

    input {
      width: 160px;
      padding-right: 52px;
    }

    &.people {
      width: 134px;

      input {
        width: 134px;
        padding-right: 38px;
      }
    }

    .unit {
      position: absolute;
      right: 1px;
      top: 1px;
      bottom: 1px;
      background-color: #e4e4e4;
      padding: 0 10px;
      line-height: 28px;
      border-radius: 0 5px 5px 0;
    }
  }

  .address {
    width: 400px;
    margin-top: 10px;
  }

  .person {
    display: inline-block;
    margin-right: 50px;
  }

  .add-btn {
    border-radius: 5px;
    display: inline-block;
    position: relative;
    overflow: hidden;
    background-color: #2d8cf0;
    color: #fff;
    font-size: 12px;
    padding: 0 10px;
    border: none;
    height: 32px;
    cursor: pointer;
    margin-top: 10px;
  }
  .map-btn {
    display: inline-block;
    width: 70px;
    height: 30px;
    padding: 0 10px;
    font-size: 12px;
    color: #fff;
    background-color: #2d8cf0;
    border-radius: 5px;
    cursor: pointer;
  }
  .map-data {
    span {
      display: inline-block;
      margin-left: 10px;
    }
  }
  .icon-add {
    display: inline-block;
    width: 24px;
    height: 24px;
    margin: 3px 0 3px 10px;
    background: url(~@/assets/images/icon-add.png) no-repeat center;
    cursor: pointer;
  }
  .icon-delete {
    display: inline-block;
    width: 24px;
    height: 24px;
    margin: 3px 0 3px 10px;
    background: url(~@/assets/images/icon-delete.png) no-repeat center;
    cursor: pointer;
  }
}
</style>
